import { render, staticRenderFns } from "./ing.vue?vue&type=template&id=2948a0b7&scoped=true&"
import script from "./ing.vue?vue&type=script&lang=js&"
export * from "./ing.vue?vue&type=script&lang=js&"
import style0 from "./ing.vue?vue&type=style&index=0&id=2948a0b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948a0b7",
  null
  
)

export default component.exports